import { render } from "./TeamStatus.vue?vue&type=template&id=c7d8c8f8"
import script from "./TeamStatus.vue?vue&type=script&lang=js"
export * from "./TeamStatus.vue?vue&type=script&lang=js"

import "./TeamStatus.vue?vue&type=style&index=0&id=c7d8c8f8&lang=scss"
script.render = render

export default script